/** Console origin for Stripe success/cancel/return URL resolution on the API. */
export const getReportingMonetizationBaseUrl = (): string =>
  typeof window !== 'undefined' ? window.location.origin : '';
